import React from "react";

const ClientButton = (props) => {
  return (
    <div
      {...props}
      style={{...styles?.topButton, ...props.style}}
      onMouseDown={(e) => {
        e.currentTarget.style.boxShadow = "0 0 10px rgba(0,0,0,0.4)";
      }}
      onMouseUp={(e) => {
        e.currentTarget.style.boxShadow = "none";
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.boxShadow = "0 1px 52px rgba(0,0,0,0.3)")
      }
      onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
    >
      {props.children}
    </div>
  );
};

const styles = {
  topButton: {
    fontSize: "20px",
    cursor: "pointer",
    borderRadius: "15px",
    // transition: "opacity 0.2s ease",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default ClientButton